import { numberRequiredSchema, select2RequiredSchema, stringLengthSchema, stringSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const goalFormSchema = object().shape({
	discipline_id: numberRequiredSchema,
	area_id: select2RequiredSchema,
	goal_id: select2RequiredSchema,
	context_id: select2RequiredSchema,
	goal_description: stringLengthSchema(350),
	// goal_notes: stringSchema(),
});

export default goalFormSchema;